import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadChaos'

const Download: React.FunctionComponent = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'カオスマップ スマホアプリ モバイルアプリ グロース アプリ開発'}
        image={'https://aitria.co.jp/images/img/download/chaos/ogp.png'}
        url={'https://aitria.co.jp/download/mobile-app-technology-chaos-map-2025/'}
        title="モバイルアプリテクノロジーカオスマップ2025 | 資料ダウンロード | Aitria（アイトリア）"
        description="モバイルアプリのグロースサイクルを軸とした、国内外の主要な92のソリューションを網羅的に紹介した資料です。"
      />
      <Template />
    </>
  )
}

export default Download
